define('view/controller/booking/result/BookingResultLayout',['require','marionette','lib/plugin/PluginBroker','view/controller/booking/result/BookingPushNotificationView','plugin/push-notifications/model/PushNotificationsModel','view/controller/booking/result/BookingResultView','view/controller/booking/result/BookingResultPopup','collection/BookingCollection','collection/WaitingListCollection','view/module/MessageView','lib/view/ModalRegion','lib/model/BaseModel','Config','lib/view/mixin/BookingResultPopupMixin'],function (require) {
	
	var Marionette = require('marionette');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var BookingPushNotificationView = require('view/controller/booking/result/BookingPushNotificationView');
    var PushNotificationsModel = require('plugin/push-notifications/model/PushNotificationsModel');
    var BookingResultView = require('view/controller/booking/result/BookingResultView');
    var BookingResultPopup = require('view/controller/booking/result/BookingResultPopup');
    var BookingCollection = require('collection/BookingCollection');
    var WaitingListCollection = require('collection/WaitingListCollection');
    var MessageView = require('view/module/MessageView');
    var ModalRegion = require('lib/view/ModalRegion');
    var BaseModel = require('lib/model/BaseModel');
    var Config = require('Config');
    var BookingResultPopupMixin = require('lib/view/mixin/BookingResultPopupMixin');

	/**
	 * Booking result layout
	 * 
	 * @class BookingResultLayout
	 */
	return Marionette.LayoutView.extend({
	
	    template: '#booking_result_layout',
        regions: {
	        message: '#sb_message_container',
            bookingsList: '#sb_bookings_list',
            pushNotification: '#sb_push_notification_container'
        },
        ui: {
	        likePopup: '#sb_like_popup',
            closeLikePopup: '#sb_close_popup'
        },
        events: {
	        'click @ui.closeLikePopup': 'closePopup'
        },
        _data: {},
        _cancelledBooking: null,
        _listView: null,
        _pushNotifyView: null,
        _clientModel : null,
        _fbUrl: '//connect.facebook.net/en_US/sdk.js',
        _likeButtonShown: false,

        initialize: function () {
            this._data = this.getOption('data');
        },
        
        _onCancelSuccess: function () {
            this._showBookingsList();
        },
        
        onBeforeShow: function () {
            this._showBookingsList();
        },

        _showBookingsList: function () {
            var collection = new BookingCollection();
            var data = {};

	        if(this._data && this._data.wl && parseInt(this._data.wl)){
	            collection = new WaitingListCollection();
            }

            if (this._data.booking_ids) {
                data.booking_ids = this._data.booking_ids.split(',');
            }
            if (this._data.type) {
                data.type = this._data.type;
            }

            collection.fetch({
                data: data
            });

            this._clientModel = this.getOption('clientModel');

            this.listenTo(collection, 'destroy', this.onBookingCancelled);
            this.listenTo(this._clientModel, 'sync', function () {
                collection.fetch({
                    data: data
                });
            });

            this._listView = new BookingResultView({
                clientTimeZone: this.getOption('clientTimeZone'),
                collection: collection,
                collectionData: data,
                data: this._data,
                wl: !!parseInt(this._data.wl),
                clientModel: this._clientModel
            });
            this.listenTo(this._listView, 'cancel:success', this._onCancelSuccess);
            this.showChildView('bookingsList', this._listView);

            if (this._data.status) {
                var smessage = Locale.getNonEscape('booking_status_' + this._data.status);

                if(this._data.status == 'success' && !!parseInt(this._data.wl)){
                    smessage = Locale.getNonEscape('You have successfully booked in a waiting list. You will receive an email as soon as the free space appears' );
                }
                this.showResultPopup(this._data, smessage);

                // this.showChildView('message', new MessageView({
                //     type: 'info',
                //     message: smessage
                // }));
            }
            PluginBroker.getInstance().perform('onShowClientBookings', [this, this._data]);

            //this.listenTo(this._clientModel, 'sync', this.showPushNotificationView);
            //this.showPushNotificationView();
        },

        showResultPopup: function (data, mess) {
            var region = new ModalRegion();

           if(!BookingResultPopupMixin.isShowBookingResultPopup(data)){
                return;
           }

            var view = new BookingResultPopup({
                region: region,
                model: new BaseModel({
                    status: data.status,
                    booking_ids: data.booking_ids,
                    message: mess,
                    invoice: false,
                }),
            });
            region.show(view);
        },

        onBookingCancelled: function (model) {
            var isBatch = !!model.get('_cancel_batch');
            
            this.showChildView('message', new MessageView({
                type: 'success',
                message: isBatch ? 'bookings_have_successfully_cancelled' : 'booking_has_successfully_cancelled', 
                model: model,
                triggerEventOnShown: true
            }));

            //this._listView.refreshCollection();
        },

        serializeData: function () {
            var result = Marionette.LayoutView.prototype.serializeData.apply(this);
            result.all_bookings_shown = this._data.booking_ids ? false : true;
            result.type = this._data.type;

            result.wl = this._data.wl ? parseInt(this._data.wl) : false;

            // hide show all booking page for widget
            if (window.self !== window.top) {
                result.all_bookings_shown = true;
            }

            result.show_like_button = document.cookie && document.cookie.indexOf('_btn_like_shown') === -1;
            if (Config.getInstance().getOption('white_label')) {
                result.show_like_button = false;
            }

            this._likeButtonShown = result.show_like_button;

            return result;
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'my_bookings'
            });

            this.handleLikeButton();
        },

        /**
         * Handle like button
         */
        handleLikeButton: function () {
            if (this._likeButtonShown) {
                if (typeof FB === 'undefined') {
                    this.loadFb();
                } else {
                    this.loadFbAsync();
                }

                var expires = new Date();
                expires.setDate(expires.getDate() + 30);

                document.cookie = '_btn_like_shown=1; expires=' + expires.toUTCString();
            }
        },

        /**
         * Load fb sdk
         */
        loadFb: function () {
            window.fbAsyncInit = _.bind(this.loadFbAsync, this);

            jQuery.getScript(this._fbUrl);
        },

        /**
         * Init sdk
         */
        loadFbAsync: function () {
	        FB.init({
                appId: Config.getInstance().getOption('fb_app_id'),
                cookie: true,
                xfbml: true,
                version: 'v2.5'
            });
        },

        closePopup: function () {
            this.ui.likePopup.hide();
        }

	});
	
});
